//--------------
// get previous
//--------------
export default function getPrevious(id, array) {
    let match = null;
    let idx = array.findIndex((x) => x.id === id);
    idx--;
    if (idx < 0) idx = array.length - 1;
    match = array[idx];
    //---------
    // returns
    //---------
    return match;
  }